import React, { useState, useEffect } from 'react';
import UserInfo from './UserInfo';
import { apiCall } from '../apiclient';
import { Table } from 'react-bootstrap';
import { User } from '../classes/User';

export default function UserList(props) {   
    // var userList = [];

    const [userList, setUserList] =
        useState([]);
    
    useEffect(() => { 
        // console.log("in UserList.useEffect()");
            
        apiCall('get', 'users?role=user').then((uList) => {
            // console.log(uList);
            let tempList = [];
            try {
                uList.users.map((u) => {
                    if(u.name !== 'RootAdmin' && u.name !== props.user.name) {
                        // console.log(`pushing ${u.name}`);
                        tempList.push(new User(u));
                    }
                });
                // console.log("setting userList: " + JSON.stringify(tempList));
                setUserList(tempList);
            } catch (mapErr) {
                console.log(mapErr);
            }
            // console.log("UserAdmin.useEffect() setUserList: " + JSON.stringify(users));
        }).catch( (error) => {
            console.log(JSON.stringify(error));
            // props.updateUser({uuid:null});
        });
    }, []);

    function fireEvent(evt, uData) {
        props.selectUser(JSON.parse(uData));
    }

    return(
        <div class="mx-auto w-75">
            <p></p>
        <Table striped bordered hover size="sm">
            <thead>
                <tr>
                    <th>Display Name</th>
                    <th>E-Mail Address</th>
                    <th>Roles</th>
                </tr>
            </thead>
            <tbody>
              {userList.map((u) => (
                <tr onClick={(evt) => fireEvent(evt, JSON.stringify(u))} >
                    <td>{u.data.display_name}</td><td>{u.data.email}</td><td>{u.role_names}</td>
                </tr>
              ))}
            </tbody>
        </Table>
        </div>
    )
}